import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { AuthorizedRoute } from '@tshio/react-router-permissions';
import { Role } from 'api/types/auth';
import OnboardingVideoPage from 'pages/OnboardingVideoPage';

const OnboardingVideoRoute = ({ path }: { path: string }) => {
  return (
    <AuthorizedRoute requires={[Role.HOST]} path={path}>
      {({ isAuthorized }) =>
        isAuthorized ? (
          <Route path={path} component={OnboardingVideoPage} />
        ) : (
          <Redirect
            to={{
              pathname: '/login/',
              state: {
                next: '/dashboard/',
                redirectReason: 'You have to login as a Host to be able to access this page.',
              },
            }}
          />
        )
      }
    </AuthorizedRoute>
  );
};
export default OnboardingVideoRoute;
